module.exports = __webpack_public_path__ + "img/statered_bg.24ca6612.png";